var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.665878 5.5253L13.0382 6.88396L11.958 8.71123C11.6301 9.26776 12.3379 9.85026 12.8315 9.43212L17.7989 5.22106C18.067 4.99326 18.067 4.58217 17.7989 4.35436L12.8315 0.143303C12.3376 -0.27706 11.6301 0.307664 11.958 0.861966L13.036 2.69146L0.665878 4.04827C-0.221584 4.14325 -0.222335 5.42994 0.665878 5.5253Z",
    fill: "#B7BED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5cbe18ab4a68b91150d1a5113fcd618b.svg";
export { ForwardRef as ReactComponent };